module.exports = __webpack_public_path__ + "static/media/level2_1.baa1aa87.png";